export const DIALOG_INFO = 'DIALOG_INFO';
export const DIALOG_SHARE = 'DIALOG_SHARE';
export const DIALOG_WARNING = 'DIALOG_WARNING';
